import get from 'transmute/get';
import { createSelector } from 'reselect';
import { getPortal } from './getPortal';
export const getLimits = createSelector(getPortal, get('limits'));